<template>
<q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding>
        <component :is="dataView"></component>
      </q-page>
    </q-page-container>
</q-layout>
</template>

<script>
const General = () => import('./view.general.vue')
// eslint-disable-next-line
export default {
  data () {
    return {}
  },
  computed: {
    dataView() {
      return General
    },
  }
}
</script>
